import { ClientMetaFunction, mergeMeta } from '@app/utils/remix/play-now-meta';
import { loadSectionDetail } from '@play-now/video/api/pac/load-section-detail';
import { getRemixMeta } from '@play-now/video/components/Meta/PlayMetaData';
import { useInitialData } from '@play-now/video/config/VideoAppContext';
import { PreloadedSections, SectionDetailsType } from '@play-now/video/models/Section';
import { SectionDetailPage } from '@play-now/video/pages/SectionDetail/SectionDetailPage';
import { json, LoaderFunctionArgs } from '@remix-run/node';
import { useLoaderData } from '@remix-run/react';

import { PlayLayout } from './PlayLayout';
import { setupPlayUtils } from './remix-route-helper';

export const loader = async (args: LoaderFunctionArgs) => {
  const {
    query: { preview, id },
    axios,
    config,
  } = setupPlayUtils(args);
  const sectionDetail: SectionDetailsType = await loadSectionDetail(axios, id, !!preview);
  const preloadedSections: PreloadedSections = { [id]: sectionDetail };

  const metaData = getRemixMeta({
    config,
    title: sectionDetail.representation.title,
    description: sectionDetail.representation.description,
    image: sectionDetail.sectionType === 'MediaSectionWithShow' ? sectionDetail.representation.imageUrl : undefined,
  });

  return json({ preloadedSections, meta: metaData });
};

export const meta: ClientMetaFunction<typeof loader> = ({ data, matches }) => mergeMeta({ data, matches });

const SectionDetailPageRoute = () => {
  const initialData = useInitialData();
  const { preloadedSections } = useLoaderData<typeof loader>();
  if (preloadedSections) {
    initialData.preloadedSections = preloadedSections as PreloadedSections;
  }

  return (
    <PlayLayout pageId='event'>
      <SectionDetailPage initialData={initialData} />
    </PlayLayout>
  );
};

export default SectionDetailPageRoute;
